<template>
    <div id="`familylist`">
        <app-gridview 
            v-bind:parentData = "{
                tabHeaders: this.dataHeader,
                tabItems: this.dataItems,
                pageTitle: this.pageTitle,
                search: this.search,
            }"
            v-on:EditItem="editItemHandler($event)"
            v-on:DeleteItem="deleteItemHandler($event)"
            v-on:NewPressed="newRecordHandler"
        ></app-gridview>
    </div>
</template>

<script>
import moment from 'moment';

import GridView from '../../../components/common/GridView';

export default {
    components: {
        'app-gridview': GridView
    },

    data() {
        return {
            pageTitle: this.$t('recfamdetails.familylist'), 
            dataHeader: [
                { text: this.$t('columns.actions') ,          value: 'action',            sortable: false},
                { text: this.$t('columns.staffname'),       value: 'psnname',           width: '200px'},
                { text: this.$t('recfamdetails.membername'),       value: 'membername',        width: '200px' },
                { text: this.$t('setupreport_exportmapping.relationship'),      value: 'memberdesc',      width: '150px' },
                { text: this.$t('columns.dob'),              value: 'dob',               width: '150px' },
                { text: this.$t('recpersonalinfo.salutation'),       value: 'salutname',           width: '150px' },
                { text: this.$t('columns.gender'),           value: 'gendername',          width: '150px' },
                { text: this.$t('recpersonalinfo.maritalstatus'),     value: 'marstatname',         width: '150px' },
                { text: this.$t('recfamdetails.working'),          value: 'isWorking',         width: '120px' },
                { text: this.$t('recfamdetails.studying'),         value: 'isStudying',         width: '120px' },
                { text: this.$t('columns.remark'),           value: 'remark',            width: '200px' },
                
            ],

            dataItems: [],
            loading: false,
            errMsg: '',
            search: this.$route.params.search,
        }
    },

    methods: {
        getFamilyListHandler() {
            const vm = this;

            this.loading = !this.loading;

            this.$store.dispatch('get', {url: '/family/all'})
                .then(function (res) {
                    vm.dataItems = res.data.rec;
                    console.log('family', vm.dataItems)
                    

                    for (let i = 0; i < vm.dataItems.length; i++) {

                        if (vm.dataItems[i].dob) {
                            vm.dataItems[i].dob = moment(vm.dataItems[i].dob).format('YYYY-MM-DD');
                        }

                        if (vm.dataItems[i].startdate) {
                            vm.dataItems[i].startdate = moment(vm.dataItems[i].startdate).format('YYYY-MM-DD');
                        }

                        if (vm.dataItems[i].enddate) {
                            vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format('YYYY-MM-DD');
                        }
                    }

                    vm.loading = !vm.loading;
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });

        },

        editItemHandler(item) {
            this.$router.push({name: 'familyedit', params: { id: item.id, search: item.search } });
        },

        newRecordHandler() {
            this.$router.push({name: 'familynew'});
        }
    },

    mounted() {
        this.getFamilyListHandler();
    }
}
</script>